export default {
    loading: "Bezig met laden"
}